import { Button, Input, Progress, Select, Space, TableProps } from "antd";
import { Link } from "react-router-dom";
import AddIcon from "../../../assets/icons/AddIcon";
import ArchivedIcon from "../../../assets/icons/ArchivedIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../assets/icons/SelectDownIcon";
import ViewIcon from "../../../assets/icons/ViewIcon";
import StatusItem from "../../../components/common/StatusItem";
import TitleBar from "../../../components/common/TitleBar";
import CustomTable from "../../../components/ui/CustomTable";
import colors from "../../../constants/colors";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { countParPageSerialNumber } from "../../../utils/number";
import { valueOrNa } from "../../../utils/string";
import {
  addKeyInArray,
  selectArrayOption,
  selectSearchOption,
} from "../../../utils/utils";

type TableStatus = {
  status: string;
};

export default function OrganizationList() {
  const {
    page,
    limit,
    filter,
    handleFilter,
    handleLimit,
    handlePagination,
    handleSearch,
  } = useTable<TableStatus>();

  const columns: TableProps<any>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Org. ID",
      dataIndex: "employee_id",
      render: (val) => valueOrNa(val),
    },
    {
      title: "Organization Mane",
      dataIndex: "member",
      render: (val) => valueOrNa(val),
    },
    {
      title: "Join at",
      dataIndex: "member",
      render: (val) => valueOrNa(val),
    },
    {
      title: "Total Spent (BDT)",
      dataIndex: "mobile",
      render: (val) => valueOrNa(val),
    },
    {
      title: "Hired",
      dataIndex: "mobile",
      align: "center",
      width: 200,
      render: (val) => (
        <Progress
          percent={74}
          status="active"
          percentPosition={{
            align: "center",
          }}
          trailColor="#D9D9D9"
          strokeColor={colors.success.color}
          className="text-[#1C222B] text-sm font-medium w-20 custom-progress"
        />
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (val) => <StatusItem value="Active" list={statusList} />,
    },
    {
      title: "Action",
      dataIndex: "id",
      align: "center",
      width: 130,
      render: (val) => (
        <Space align="center">
          <Link to={`view/${val}`}>
            <Button className="action-view" size="small" icon={<ViewIcon />} />
          </Link>
          <Button
            className="action-delete"
            size="small"
            icon={<ArchivedIcon />}
          />
        </Space>
      ),
    },
  ];

  return (
    <SidebarLayout title="Organizations">
      <TitleBar title="Organizations List">
        <Link to="add">
          <Button icon={<AddIcon />} type="primary" className="sm-button !px-3">
            Add New
          </Button>
        </Link>
      </TitleBar>

      <CustomTable
        loading={false}
        limit={limit}
        page={page}
        columns={columns}
        total={10}
        dataSource={addKeyInArray([{}])}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder="Search"
              style={{ minWidth: 170, maxWidth: 180 }}
              onChange={(val) => handleSearch(val)}
            />

            <Select
              allowClear
              showSearch
              placeholder="Status"
              filterOption={selectSearchOption}
              options={selectArrayOption(statusList, "label", "value")}
              className="min-w-[90px]"
              suffixIcon={<SelectDownIcon />}
              rootClassName="icon-gray"
              value={filter.status}
              onChange={(val) => handleFilter("status", val)}
              popupMatchSelectWidth={120}
            />
          </>
        }
      />
    </SidebarLayout>
  );
}

const statusList = [
  {
    label: "Active",
    value: "Active",
    className: "bg-status-success-text text-white",
  },
  {
    label: "De-activated",
    value: "De-activated",
    className: "bg-status-danger-text text-white",
  },
  {
    label: "Archived",
    value: "Archived",
    className: "bg-status-dark-text text-white",
  },
];
